import { render, staticRenderFns } from "./changemaker-details.vue?vue&type=template&id=6a124ee4&scoped=true&"
import script from "./changemaker-details.vue?vue&type=script&lang=js&"
export * from "./changemaker-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a124ee4",
  null
  
)

export default component.exports